import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AssignedActionKind } from '../../../../../../../gen/ts/mono/datagateway/v1/delivery_pb';
import { useAuth } from '../../../../contexts/authContext';
import { projectDataClient } from '../../../../lib/connect/clients';
export function AssignedSectionWork({ projectId }) {
    const { user } = useAuth();
    const [offset, setOffset] = useState(0);
    const limit = 20;
    const feed = useQuery({
        queryKey: [
            'proposal-assigned-actions',
            user?.tenant_id,
            user?.id,
            projectId,
            offset
        ],
        enabled: !!user && !!projectId,
        queryFn: ()=>projectDataClient.listMyProposalAssignedActions({
                projectId,
                limit,
                offset
            })
    });
    return /*#__PURE__*/ _jsxs("section", {
        "aria-label": "My assigned section work",
        "data-testid": Testids.proposalWork.panel,
        className: "mb-4 space-y-2 rounded border border-border bg-card p-4 text-foreground",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "font-semibold",
                children: "My assigned section work"
            }),
            feed.isLoading ? /*#__PURE__*/ _jsx("output", {
                children: "Loading assigned section work…"
            }) : feed.isError ? /*#__PURE__*/ _jsxs("div", {
                role: "alert",
                children: [
                    "Unable to load assigned section work.",
                    ' ',
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        onClick: ()=>feed.refetch(),
                        children: "Retry assigned work"
                    })
                ]
            }) : feed.data?.actions.length === 0 ? /*#__PURE__*/ _jsx("p", {
                children: "No section writing or review assignments."
            }) : /*#__PURE__*/ _jsx("ul", {
                className: "space-y-2",
                children: feed.data?.actions.map((action)=>/*#__PURE__*/ _jsxs("li", {
                        "data-testid": Testids.proposalWork.row,
                        "data-action-id": action.id,
                        children: [
                            /*#__PURE__*/ _jsx(Link, {
                                "data-testid": Testids.proposalWork.sectionLink,
                                to: `/proposal/${action.projectId}/v2/volume/${action.volumeId}/section/${action.sectionId}`,
                                className: "text-brand hover:underline",
                                children: action.title
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: action.kind === AssignedActionKind.PROPOSAL_WRITER ? 'Section writer' : action.kind === AssignedActionKind.PROPOSAL_REVIEWER ? 'Section reviewer' : 'Section assignment'
                            }),
                            action.volumeName && /*#__PURE__*/ _jsx("p", {
                                children: action.volumeName
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    "Internal date:",
                                    ' ',
                                    action.internalDate ? /*#__PURE__*/ _jsx("time", {
                                        dateTime: action.internalDate,
                                        children: action.internalDate
                                    }) : 'Not set'
                                ]
                            })
                        ]
                    }, action.id))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        variant: "secondary",
                        "data-testid": Testids.proposalWork.previous,
                        disabled: offset === 0 || feed.isFetching,
                        onClick: ()=>setOffset((current)=>Math.max(0, current - limit)),
                        children: "Previous assignments"
                    }),
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        variant: "secondary",
                        "data-testid": Testids.proposalWork.next,
                        disabled: !feed.data?.hasMore || feed.isFetching || feed.isError,
                        onClick: ()=>setOffset((current)=>current + limit),
                        children: "Next assignments"
                    })
                ]
            })
        ]
    });
}
